export default "__VITE_ASSET__wCrWCb32__"